(function() {
  'use strict';

  function ModalMsgController($uibModalInstance, msgBackEnd) {

    var modalMsg = this;

    modalMsg.msg = msgBackEnd;

    modalMsg.back = function() {
      $uibModalInstance.dismiss('cancel');
    };

  };

  angular
    .module('mandaeApp')
    .controller('ModalMsgController', ModalMsgController);
})();
